import React from "react";
import { getMagnoliaHost } from "@/utilities/functions/magnoliaUtils";
import "./Image.scss";

const Image = ({ image = {} } : { image: any} ) => {
    if (!Object.keys(image).length) return
    const mgnlHost = getMagnoliaHost();
    const hasImage = image.metadata || false

    if(!hasImage) return

    const { height, width, caption } = image.metadata
    return <img src={`${mgnlHost}${image['@link']}`} alt={caption} width={width} height={height} title={caption}/>
}

export default Image;